export default __webpack_public_path__ + "d48e190f9c84dbde5275abab081ca0e3.svg";